import PropTypes from "prop-types";

const MissingComponent = () => null;
export default function select(componentMap = new Map()) {
    const Select = (props) => {
        const { value, children, ...otherProps } = props;
        const Component = componentMap.get(value) ?? MissingComponent;
        return <Component {...otherProps}>{children}</Component>;
    };

    Select.propTypes = {
        value: PropTypes.any.isRequired,
    };

    return Select;
}
